import React from "react";
import { useTranslation } from "react-i18next";

const TableHead: React.FC = () => {
    const { t } = useTranslation();
    return (
        <>
            <thead>
                <tr className="fs-7">
                    <th className="col-1 ps-lg-4">{t("Request Date")}</th>
                    <th className="col-1">{t("Status")}</th>
                    <th className="col-1">ID</th>
                    <th className="col-1">{t("Restaurant")}</th>
                    <th className="col-1">{t("Client Name")}</th>
                    <th className="col-2">{t("Contacts")}</th>
                    <th className="col-2">{t("Date and Time")}</th>
                    <th className="col-1 text-wrap">{t("Number of guests")}</th>
                    <th className="col-1">{t("Wish")}</th>
                    <th className="col-1"></th>
                </tr>
            </thead>
        </>
    );
};

export default TableHead;
